<script setup>
const props = defineProps({
    statistics: {
        type: Object,
        required: true
    }
});
</script>
<template>
    <div>
        <forms-reporting-fields-on-line-graph :statistics="statistics" />
    </div>
</template>
